import './style.css';
import App from './App.vue';
import { createApp } from 'vue';
import Lenis from 'lenis';

// Clean up any Service Worker + Cache Storage left over from the previous
// PWA-enabled build. Without this, returning visitors with the old worker
// installed keep getting served the old cached site indefinitely.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
}
if ('caches' in window) {
  caches.keys().then((keys) => {
    keys.forEach((key) => caches.delete(key));
  });
}

// smooth scroll
const lenis = new Lenis({
  duration: 0.8,
});
function raf(time: number) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

const app = createApp(App);
app.mount('#app');

export { raf, lenis };
